import Tooltip,{tooltipClasses} from "@mui/material/Tooltip";
import "./Tooltip.scss";
import { styled } from "@mui/material/styles";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
      },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    margin: 0,
  },
}));

const CustomTooltip = ({
  title,
  children,
  placement = "bottom-start",
}) => {
  if (!title) return children;

  return (
    <StyledTooltip title={title} arrow placement={placement}>
      <span>{children}</span>
    </StyledTooltip>
  );
};

export default CustomTooltip;
